import { createContext, useContext } from "react";

export type FirstPageVisitedContextValue = {
  page: string;
  referrer: string;
};

export const FirstPageVisitedContext =
  createContext<FirstPageVisitedContextValue>(null);

export const useFirstPageVisited = (): FirstPageVisitedContextValue => {
  const context = useContext(FirstPageVisitedContext);

  return context;
};
